import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="colleague";
export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectPageAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}
export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}

export default {
  insert,
  update,
  selectAll,
  selectPageAll,
  selectOne
}